import cn from 'classnames';
import { ReactComponent as FilterIcon } from 'assets/icons/filter-icon.svg';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down-full.svg';
import { StyledAdminListHeaderCell } from './styles';
import { useState } from 'react';

interface IAdminListHeaderCellProps {
  children?: React.ReactNode;
  filter?: boolean;
  sort?: boolean;
  onSort?: () => void;
  onFilter?: () => JSX.Element;
  isActive?: boolean;
  sortDir?: 'ASC' | 'DESC' | 'NONE';
  fieldKey: string;
}

export const AdminListHeaderCell = ({
  children,
  filter,
  sort,
  onSort,
  onFilter,
  isActive = false,
  sortDir = 'NONE',
  fieldKey,
}: IAdminListHeaderCellProps) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  return (
    <StyledAdminListHeaderCell>
      <div className="admin-list-header-cell-title">{children}</div>
      {sort && (
        <button
          className="sort-by-button"
          onClick={onSort}
          style={{
            opacity: isActive && sortDir !== 'NONE' ? 1 : 0.6,
            transform: `scale(${isActive && sortDir !== 'NONE' ? '1.2' : '1'}) rotateZ(${
              isActive && sortDir === 'ASC' ? '180deg' : '0deg'
            })`,
            transition: 'all 0.2s ease',
          }}
        >
          <ArrowDownIcon />
        </button>
      )}

      {!sort && filter && (
        <div className="admin-list-filter-container">
          <button className="admin-list-header-cell-filter" onClick={toggleFilter}>
            <FilterIcon className="admin-list-header-cell-filter-icon" />
          </button>
          {isFilterOpen && (
            <div
              className={cn('admin-list-filter-picker', fieldKey.toLowerCase())}
              onMouseLeave={() => setIsFilterOpen(false)}
            >
              {onFilter && onFilter()}
            </div>
          )}
        </div>
      )}
    </StyledAdminListHeaderCell>
  );
};
